import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import { customBgColor } from "utils/module-settings";
import getContainerSizeClass from "@root/helpers/get-container-size-class";

const USPS = ({ data: { moduleSettings, uspsData, uspsTitle, intersectWithSectionAbove } }) => {
    const classes = getContainerSizeClass(moduleSettings);

    return (
        <div
            style={{ backgroundColor: moduleSettings.containerWidth === "wide" ? customBgColor(moduleSettings?.bgColor) : null, marginTop: intersectWithSectionAbove ? "-50px" : "0px" }}
            className={`${classes.join(" ")} rounded-md relative z-1`}
        >
            <div className="usps-container">
                <div
                    style={{ backgroundColor: customBgColor(moduleSettings?.bgColor) }}
                    className="container flex py-5 px-4 flex-wrap rounded-lg"
                >

                    {uspsTitle && (
                        <div className="usps-title w-full text-left">
                            <h2>
                                {uspsTitle}
                            </h2>
                        </div>
                    )}

                    {uspsData.map((usp) => (
                        <div key={usp._key} className="flex gap-3 xl:w-1/4 md:w-1/2 w-full py-2 items-center">
                            <div className="usps-icons">
                                <Image image={usp.icon.asset} alt={usp.icon.alt} />
                            </div>
                            <div className="flex flex-col">
                                <p style={{ color: usp.titleColor && usp.titleColor.hex }} className="pb-0.5 md:text-base text-sm font-semibold">
                                    {usp?.title}
                                </p>
                                {!usp?.subtitle?.url ? (
                                    <p style={{ color: usp.subtitleColor && usp.subtitleColor.hex }} className="md:text-sm text-xs font-medium">
                                        {usp?.subtitle?.title}
                                    </p>
                                ) : (
                                    <Link
                                        style={{ color: usp.subtitleColor && usp.subtitleColor.hex }}
                                        className="md:text-sm text-xs font-medium"
                                        to={usp.subtitle.url}
                                    >
                                        {usp?.subtitle?.title}
                                    </Link>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>        
        </div>
    );
};

export default USPS;
